import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AtomParams, AtomService } from 'src/app/core/atom.service';
import { Enum } from 'src/app/core/resources/enum.resource';

@Injectable({
  providedIn: 'root',
})
export class EnumsService {
  constructor(private atom: AtomService) {}

  byTableAndField(
    table: string,
    field: string,
    pageSize: number = 25,
    pageIndex: number = 0
  ): Observable<Enum[]> {
    return this.atom.list(Enum, {
      filter: {
        'equal.enum_table': table,
        'equal.enum_field': field,
      },
      pageSize,
      pageIndex,
    });
  }

}
